import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CloseIcon from "@mui/icons-material/Close";
import { Skeleton, Stack, Typography } from "@mui/material";
import { ExtraSmallFab } from "../../../Shared/components/Buttons/ExtraSmallFAB";
import { UpdateOrderTexts } from "../deliveryModalUtils/const-enums-types";
export const TitleComponentSkeleton = (props) => {
    return (_jsxs(Stack, Object.assign({ direction: "row", justifyContent: "space-between", alignItems: "center" }, { children: [_jsx(Skeleton, Object.assign({ variant: "rectangular", width: "50%", height: "100%" }, { children: _jsx(Typography, { children: UpdateOrderTexts.UPDATE_DELIVERY }) })), _jsx(ExtraSmallFab, { icon: CloseIcon, "aria-label": "close", onClick: props.onClose })] })));
};
